import request from "@/utils/request.js"

// 核销记录查询
export const listTicketRedemption = (pageData, formData) => {
    return request.get(`/admin/ticket/page/redemption/${pageData.page}/${pageData.pageSize}`, {params: formData})
}
